import { render } from "./ScrawlDemo.vue?vue&type=template&id=8b7a36b2&scoped=true"
import script from "./ScrawlDemo.vue?vue&type=script&lang=js"
export * from "./ScrawlDemo.vue?vue&type=script&lang=js"

import "./ScrawlDemo.vue?vue&type=style&index=0&id=8b7a36b2&lang=scss&scoped=true"

import exportComponent from "/nodeApps/scrawl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7a36b2"]])

export default __exports__